<template>
<!--  none-border-->
  <div>
    <template v-if="!isSale">
      <div class="public-more ">
        <button class="public-more-btn" @click="productList">{{$t('headerNav.Smore')}}</button>
        <!-- {{areaid}} -->
      </div>
    </template>
    <template v-else>
      <div class="sale-f">
        <button class="public-more-btn" style="margin-bottom: 0;" @click="productList">{{$t('headerNav.Smore')}}</button>
        <div class="public-more" style="height: 32px;margin-top: 0"></div>
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    name: "subfooter",
    props:{
      areaid:'',
      // 专区id
      WebFunctionID: '',
      // 类型
      TypeId:'',
      // 是否是分类页
      isFromType: false,
      // 是否是促销页
      isSale: false,
      // 是否是首页底部促销
      isIndexSale: false,
      showMoreFlag: false,
      isEperbox:false
      
    },
    data(){
      return{
        listtype: ''
      }
    },
    methods:{
      productList(){
        const _this = this;
        if(_this.TypeId == 'area') _this.listtype = 'w'
        if(_this.TypeId == 'cata' || _this.TypeId == 'wine') _this.listtype = 'c'
         if(this.isEperbox){
           _this.$router.push({
            path:'/eperBox',
          })
          return;
        }
   
        if(this.showMoreFlag) {
          this.$emit('showMore')
          return;
        }
       
        if(_this.isSale){
          _this.$router.push({
            path:'/saleList',
            query:{
              id: _this.areaid,
            }
          })
        }else if(_this.isIndexSale){
          _this.$router.push({
            path:'/sale'
         })
        }else if(_this.WebFunctionID){
          _this.$router.push({
            path:'/category',
            query:{
              WebFunctionID: _this.WebFunctionID,
              isFromType: false,
              isShowSelect: 1,
              ProductCataID: 0,
              listtype: _this.listtype
            }
         })
        }
       
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../../style/color";

  .public-more {
    @include content;
    @include borderLR(1px, $c_000);
    border-bottom: 1px solid $c_000;
    text-align: center;
  }

  .public-more-btn {
    padding: 0 54px;
    line-height: 36px;
    border: 1px solid $c_000;
    background: $c_fff;
    border-radius: 20px;
    margin: 26px auto 26px;
    font-weight: bold;
    font-size:18px;
  }
  .public-more-btn:hover{
    line-height: 36px;
    border:1px solid $c_000;
  }
  .public-more.none-border {
    margin-top: 20px;

    .public-more-btn {
      margin-top: 0;
    }
  }
  .sale-f {
    clear: both;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/public/subfooter.vue